import "./ui/style.css"
import { createRoot } from "react-dom/client"
import App from "./App"
import AdminApp from "./AdminApp"
import { BrowserRouter as Router, RouterProvider, Route, createBrowserRouter } from "react-router-dom"

const router = createBrowserRouter([
    {
        path: "/",
        element: <App lang="EN"/>,
    },
    {
        path: "/es",
        element: <App lang="ES"/>,
    },
    {
        path: "/fr",
        element: <App lang="FR"/>,
    },
    {
        path: "/it",
        element: <App lang="IT"/>,
    },
    {
        path: "/de",
        element: <App lang="DE"/>,
    },
    {
        path: "/admin",
        element: <AdminApp />
    }
]);


const root = createRoot(document.getElementById("root"))
root.render(
    <RouterProvider router={router} />
)